import { type ElementType, type FocusEvent, type ReactNode, useEffect } from "react";
import type { InputBaseComponentProps, OutlinedInputProps } from "@mui/material";
import { OutlinedInput, styled, useFormControl } from "@mui/material";

export interface OutlinedContainerProps extends Omit<OutlinedInputProps, "value"> {
  children: ReactNode;
  label?: ReactNode;
  notched?: boolean;
  focused?: boolean;
  clearable?: boolean;
  onClear?: () => void;
}

const StyledOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== "clearable" && prop !== "onClear",
})(() => ({
  cursor: "pointer",

  "& .MuiOutlinedInput-input": {
    padding: "8.5px 14px",
    flex: 1,
  },
}));

export const OutlinedContainer = ({
  children,
  notched,
  focused,
  ...props
}: OutlinedContainerProps) => {
  const formControl = useFormControl();
  const onFocus = formControl?.onFocus;
  const onBlur = formControl?.onBlur;

  // Update form control focus state when focused prop changes
  useEffect(() => {
    if (focused) {
      onFocus?.({} as FocusEvent<HTMLInputElement>);
    } else {
      onBlur?.({} as FocusEvent<HTMLInputElement>);
    }
  }, [focused, onFocus, onBlur]);

  return (
    <StyledOutlinedInput
      {...props}
      inputComponent={"div" as ElementType<InputBaseComponentProps>}
      notched={notched}
      inputProps={{
        children,
        ...props.inputProps,
      }}
    />
  );
};
